import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Springvale South - Sewer Upgrade</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We're installing a new sewer pipe to increase the capacity of the
          sewer network to cater for population growth and future proof the
          sewerage system.
        </p>
        <p>
          The project involves installing a new underground sewer pipe and
          maintenance holes running from the corner of Harold Road and Darren
          Road, down Darren Road and in Waterloo Crescent. We've awarded the
          project to Abergeldie, BMD, KBR Joint Venture (ABK). We’re now working
          with them on the detailed design and will update our website when we
          have more information.
        </p>
        <p>
          For more information click{' '}
          <a
            href="http://www.southeastwater.com.au/springvalesouth"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (orange)`,
                action: 'Link redirect',
                label:
                  'LINK TO: http://www.southeastwater.com.au/springvalesouth: Springvale South - Sewer Upgrade',
              });
            }}
          >
            here
          </a>{' '}
          or contact <a href="tel:1800330129">1800 330 129 </a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Springvale South - Sewer Upgrade',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
